<script>
import { myNameUser } from "@/mixinOld";
export default {
  name: "sideBar",
  mixins: [myNameUser],
  data() {
    return {
      activeLink: "",
      user2: this.user,
      apiDomain: this.$store.getters.getApiDomain,
    };
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
  },

  methods: {
    toggleActive(link) {
      this.activeLink = link;
      this.$router.push("/account/" + link);
    },
  },
  mounted() {
    let link = this.$route.path.split("/")[2];
    this.activeLink = link;
    const navList = this.$el.querySelector(".sidebar__nav-list");
    if (navList) {
      let isScrolling;

      navList.addEventListener("scroll", () => {
        navList.classList.add("scrolling");

        // Убираем класс через 1 секунду после остановки скролла
        clearTimeout(isScrolling);
        isScrolling = setTimeout(() => {
          navList.classList.remove("scrolling");
        }, 1000);
      });
    }
  },
};
</script>


<template>
  <div class="sidebar">
    <div class="sidebar__content">
      <router-link class="sidebar__logo" to=""
        ><img src="../../assets/image/logoSideBar.svg" alt=""
      /></router-link>
      <div class="sidebar__person">
        <div class="sidebar__person-wrapp">
          <img
            class="sidebar__person-img"
            :src="apiDomain + 'uploads/' + user?.avatar"
            alt=""
          />
          <div class="sidebar__person-info">
            <p class="sidebar__person-name">
              {{ this.user?.f }} {{ this.user?.i }}.
            </p>
            <p class="sidebar__person-position">{{ user?.position }}</p>
            <p class="sidebar__person-rating">
              <img src="../../assets/image/star.svg" alt="" />{{
                user?.rating ? user?.rating : "5.0"
              }}
            </p>
          </div>
        </div>
        <div class="sidebar__person-regalia">
          <p class="sidebar__person-regalia-text">10+<span>лет стаж</span></p>
          <p class="sidebar__person-regalia-text">
            124 380<span>стоимость</span>
          </p>
          <p class="sidebar__person-regalia-text">
            100 000<span>зарплата</span>
          </p>
        </div>
      </div>
      <nav class="sidebar__nav">
        <ul class="sidebar__nav-list">
          <li class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              @click="toggleActive('profile')"
              :class="{ active: activeLink === 'profile' }"
              to=""
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  :class="{ active: activeLink === 'profile' }"
                  id="vuesax/twotone/user-square"
                >
                  <g id="user-square">
                    <path
                      id="Vector"
                      opacity="0.4"
                      d="M18.1394 21.62C17.2594 21.88 16.2194 22 14.9994 22H8.99937C7.77937 22 6.73937 21.88 5.85938 21.62C6.07937 19.02 8.74937 16.97 11.9994 16.97C15.2494 16.97 17.9194 19.02 18.1394 21.62Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M22 9V15C22 18.78 20.86 20.85 18.14 21.62C17.26 21.88 16.22 22 15 22H9C7.78 22 6.74 21.88 5.86 21.62C3.14 20.85 2 18.78 2 15V9C2 4 4 2 9 2H15C20 2 22 4 22 9Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_3"
                      opacity="0.4"
                      d="M15.5799 10.58C15.5799 12.56 13.9799 14.17 11.9999 14.17C10.0199 14.17 8.41992 12.56 8.41992 10.58C8.41992 8.60002 10.0199 7 11.9999 7C13.9799 7 15.5799 8.60002 15.5799 10.58Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Профиль<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'profile' }"
                alt=""
            /></router-link>
          </li>

          <li class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              @click="toggleActive('message')"
              :class="{ active: activeLink === 'message' }"
              to=""
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="vuesax/twotone/message-2">
                  <g
                    :class="{ active: activeLink === 'message' }"
                    id="message-2"
                  >
                    <path
                      id="Vector"
                      opacity="0.4"
                      d="M8.5 10.5H15.5"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M7 18.4299H11L15.45 21.39C16.11 21.83 17 21.3599 17 20.5599V18.4299C20 18.4299 22 16.4299 22 13.4299V7.42993C22 4.42993 20 2.42993 17 2.42993H7C4 2.42993 2 4.42993 2 7.42993V13.4299C2 16.4299 4 18.4299 7 18.4299Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Сообщения<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'message' }"
                alt=""
            /></router-link>
          </li>

          <li class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('view')"
              :class="{ active: activeLink === 'view' }"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="vuesax/twotone/eye">
                  <g :class="{ active: activeLink === 'view' }" id="eye">
                    <path
                      id="Vector"
                      opacity="0.4"
                      d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M11.9998 20.27C15.5298 20.27 18.8198 18.19 21.1098 14.59C22.0098 13.18 22.0098 10.81 21.1098 9.39997C18.8198 5.79997 15.5298 3.71997 11.9998 3.71997C8.46984 3.71997 5.17984 5.79997 2.88984 9.39997C1.98984 10.81 1.98984 13.18 2.88984 14.59C5.17984 18.19 8.46984 20.27 11.9998 20.27Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Просмотры<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'view' }"
                alt=""
            /></router-link>
          </li>

          <li class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('company')"
              :class="{ active: activeLink === 'company' }"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="vuesax/twotone/buliding">
                  <g
                    :class="{ active: activeLink === 'company' }"
                    id="buliding"
                  >
                    <path
                      id="Vector"
                      d="M2 22H22"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M17 2H7C4 2 3 3.79 3 6V22H21V6C21 3.79 20 2 17 2Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_3"
                      opacity="0.4"
                      d="M7 16.5H10"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_4"
                      opacity="0.4"
                      d="M14 16.5H17"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_5"
                      opacity="0.4"
                      d="M7 12H10"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_6"
                      opacity="0.4"
                      d="M14 12H17"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_7"
                      opacity="0.4"
                      d="M7 7.5H10"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_8"
                      opacity="0.4"
                      d="M14 7.5H17"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Компании<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'company' }"
                alt=""
            /></router-link>
          </li>
          <li v-if="role == 'school'" class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('studentsList')"
              :class="{ active: activeLink === 'studentsList' }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g id="vuesax/twotone/studentsList">
                  <g
                    :class="{ active: activeLink === 'students' }"
                    id="students"
                  >
                    <path
                      d="M22 16.7397V4.6697C22 3.4697 21.02 2.5797 19.83 2.6797H19.77C17.67 2.8597 14.48 3.9297 12.7 5.0497L12.53 5.1597C12.24 5.3397 11.76 5.3397 11.47 5.1597L11.22 5.0097C9.44 3.8997 6.26 2.8397 4.16 2.6697C2.97 2.5697 2 3.4697 2 4.6597V16.7397C2 17.6997 2.78 18.5997 3.74 18.7197L4.03 18.7597C6.2 19.0497 9.55 20.1497 11.47 21.1997L11.51 21.2197C11.78 21.3697 12.21 21.3697 12.47 21.2197C14.39 20.1597 17.75 19.0497 19.93 18.7597L20.26 18.7197C21.22 18.5997 22 17.6997 22 16.7397Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      opacity="0.4"
                      d="M12 5.48999V20.49"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      opacity="0.4"
                      d="M7.75 8.48999H5.5"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      opacity="0.4"
                      d="M8.5 11.49H5.5"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Список студентов<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'studentsList' }"
                alt=""
            /></router-link>
          </li>
          <li v-if="role === 'school'" class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('studentsTransfer')"
              :class="{ active: activeLink === 'studentsTransfer' }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g id="vuesax/twotone/studentsTransfer">
                  <g
                    :class="{ active: activeLink === 'studentsTransfer' }"
                    id="studentsTransfer"
                  >
                    <path
                      d="M22 16.7397V4.6697C22 3.4697 21.02 2.5797 19.83 2.6797H19.77C17.67 2.8597 14.48 3.9297 12.7 5.0497L12.53 5.1597C12.24 5.3397 11.76 5.3397 11.47 5.1597L11.22 5.0097C9.44 3.8997 6.26 2.8397 4.16 2.6697C2.97 2.5697 2 3.4697 2 4.6597V16.7397C2 17.6997 2.78 18.5997 3.74 18.7197L4.03 18.7597C6.2 19.0497 9.55 20.1497 11.47 21.1997L11.51 21.2197C11.78 21.3697 12.21 21.3697 12.47 21.2197C14.39 20.1597 17.75 19.0497 19.93 18.7597L20.26 18.7197C21.22 18.5997 22 17.6997 22 16.7397Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      opacity="0.4"
                      d="M12 5.48999V20.49"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      opacity="0.4"
                      d="M7.75 8.48999H5.5"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      opacity="0.4"
                      d="M8.5 11.49H5.5"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Вакансии учреждения<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'studentsTransfer' }"
                alt=""
            /></router-link>
          </li>
          <li class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('transfer')"
              :class="{ active: activeLink === 'transfer' }"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="vuesax/twotone/driver-refresh">
                  <g
                    :class="{ active: activeLink === 'transfer' }"
                    id="driver-refresh"
                  >
                    <path
                      id="Vector"
                      opacity="0.4"
                      d="M6 6.25V8.25"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M22 12V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H12"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_3"
                      opacity="0.4"
                      d="M10 6.25V8.25"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_4"
                      opacity="0.4"
                      d="M6 16V18"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_5"
                      opacity="0.4"
                      d="M10 16V18"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_6"
                      opacity="0.4"
                      d="M14 7.25H18"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_7"
                      d="M2 12H22"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_8"
                      d="M21.5594 20.33C20.9994 21.3 19.9494 21.95 18.7494 21.95C16.9594 21.95 15.8594 20.15 15.8594 20.15M15.9294 17.09C16.4894 16.11 17.5394 15.46 18.7494 15.46C20.9194 15.46 21.9994 17.26 21.9994 17.26M21.9994 15.25V17.25H19.9994M17.8594 20.14H15.8594V22"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Переходы<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'transfer' }"
                alt=""
            /></router-link>
          </li>

          <li v-if="role != 'school'" class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('vacancy')"
              :class="{ active: activeLink === 'vacancy' }"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="vuesax/twotone/note-2">
                  <g :class="{ active: activeLink === 'vacancy' }" id="note-2">
                    <path
                      id="Vector"
                      d="M21.6602 10.44L20.6802 14.62C19.8402 18.23 18.1802 19.69 15.0602 19.39C14.5602 19.35 14.0202 19.26 13.4402 19.12L11.7602 18.72C7.59018 17.73 6.30018 15.67 7.28018 11.49L8.26018 7.30001C8.46018 6.45001 8.70018 5.71001 9.00018 5.10001C10.1702 2.68001 12.1602 2.03001 15.5002 2.82001L17.1702 3.21001C21.3602 4.19001 22.6402 6.26001 21.6602 10.44Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_2"
                      opacity="0.4"
                      d="M15.0603 19.3901C14.4403 19.8101 13.6603 20.1601 12.7103 20.4701L11.1303 20.9901C7.16034 22.2701 5.07034 21.2001 3.78034 17.2301L2.50034 13.2801C1.22034 9.3101 2.28034 7.2101 6.25034 5.9301L7.83034 5.4101C8.24034 5.2801 8.63034 5.1701 9.00034 5.1001C8.70034 5.7101 8.46034 6.4501 8.26034 7.3001L7.28034 11.4901C6.30034 15.6701 7.59034 17.7301 11.7603 18.7201L13.4403 19.1201C14.0203 19.2601 14.5603 19.3501 15.0603 19.3901Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_3"
                      opacity="0.4"
                      d="M12.6406 8.53003L17.4906 9.76003"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_4"
                      opacity="0.4"
                      d="M11.6602 12.3999L14.5602 13.1399"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Вакансии<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'vacancy' }"
                alt=""
            /></router-link>
          </li>

          <li v-if="role != 'school'" class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('statistic')"
              :class="{ active: activeLink === 'statistic' }"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="vuesax/twotone/status-up">
                  <g
                    :class="{ active: activeLink === 'statistic' }"
                    id="status-up"
                  >
                    <path
                      id="Vector"
                      opacity="0.4"
                      d="M6.88086 18.1501V16.0801"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      id="Vector_2"
                      opacity="0.4"
                      d="M12 18.15V14.01"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      id="Vector_3"
                      opacity="0.4"
                      d="M17.1191 18.1499V11.9299"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <g id="Group 709" opacity="0.4">
                      <path
                        id="Vector_4"
                        d="M17.1189 5.84961L16.6589 6.38961C14.1089 9.36961 10.6889 11.4796 6.87891 12.4296"
                        stroke="#1A1A1A"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        id="Vector_5"
                        d="M14.1895 5.84961H17.1195V8.76961"
                        stroke="#1A1A1A"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <path
                      id="Vector_6"
                      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Cтатистика<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'statistic' }"
                alt=""
            /></router-link>
          </li>

          <li class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('auction')"
              :class="{ active: activeLink === 'auction' }"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="vuesax/twotone/barcode">
                  <g :class="{ active: activeLink === 'auction' }" id="barcode">
                    <path
                      id="Vector"
                      d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_2"
                      opacity="0.4"
                      d="M6 8V16"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_3"
                      d="M9 8V12"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_4"
                      d="M9 15V16"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_5"
                      d="M15 8V9"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_6"
                      opacity="0.4"
                      d="M12 8V16"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_7"
                      d="M15 12V16"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_8"
                      opacity="0.4"
                      d="M18 8V16"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Аукционы<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'auction' }"
                alt=""
            /></router-link>
          </li>

          <li class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('favorites')"
              :class="{ active: activeLink === 'favorites' }"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="vuesax/twotone/heart">
                  <g :class="{ active: activeLink === 'favorites' }" id="heart">
                    <path
                      id="Vector"
                      d="M12.62 20.8101C12.28 20.9301 11.72 20.9301 11.38 20.8101C8.48 19.8201 2 15.6901 2 8.6901C2 5.6001 4.49 3.1001 7.56 3.1001C9.38 3.1001 10.99 3.9801 12 5.3401C13.01 3.9801 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.6001 22 8.6901C22 15.6901 15.52 19.8201 12.62 20.8101Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Избранное<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'favorites' }"
                alt=""
            /></router-link>
          </li>
          <li v-if="role === 'school'" class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('landing')"
              :class="{ active: activeLink === 'landing' }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g id="vuesax/twotone/landing">
                  <g :class="{ active: activeLink === 'landing' }" id="landing">
                    <path
                      d="M22 10.9V4.1C22 2.6 21.36 2 19.77 2H15.73C14.14 2 13.5 2.6 13.5 4.1V10.9C13.5 12.4 14.14 13 15.73 13H19.77C21.36 13 22 12.4 22 10.9Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      opacity="0.4"
                      d="M22 19.9V18.1C22 16.6 21.36 16 19.77 16H15.73C14.14 16 13.5 16.6 13.5 18.1V19.9C13.5 21.4 14.14 22 15.73 22H19.77C21.36 22 22 21.4 22 19.9Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.5 13.1V19.9C10.5 21.4 9.86 22 8.27 22H4.23C2.64 22 2 21.4 2 19.9V13.1C2 11.6 2.64 11 4.23 11H8.27C9.86 11 10.5 11.6 10.5 13.1Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      opacity="0.4"
                      d="M10.5 4.1V5.9C10.5 7.4 9.86 8 8.27 8H4.23C2.64 8 2 7.4 2 5.9V4.1C2 2.6 2.64 2 4.23 2H8.27C9.86 2 10.5 2.6 10.5 4.1Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Лендинг<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'landing' }"
                alt=""
            /></router-link>
          </li>
          <li v-if="role === 'school'" class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('billingSchool')"
              :class="{ active: activeLink === 'billingSchool' }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g id="vuesax/twotone/billingSchool">
                  <g
                    :class="{ active: activeLink === 'billingSchool' }"
                    id="billingSchool"
                  >
                    <path
                      opacity="0.4"
                      d="M18.5 12.6499V16.3499C18.5 19.4699 15.59 21.9999 12 21.9999C8.41 21.9999 5.5 19.4699 5.5 16.3499V12.6499C5.5 15.7699 8.41 17.9999 12 17.9999C15.59 17.9999 18.5 15.7699 18.5 12.6499Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.5 7.65C18.5 8.56 18.25 9.4 17.81 10.12C16.74 11.88 14.54 13 12 13C9.46 13 7.26 11.88 6.19 10.12C5.75 9.4 5.5 8.56 5.5 7.65C5.5 6.09 6.22999 4.68 7.39999 3.66C8.57999 2.63 10.2 2 12 2C13.8 2 15.42 2.63 16.6 3.65C17.77 4.68 18.5 6.09 18.5 7.65Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.5 7.65V12.65C18.5 15.77 15.59 18 12 18C8.41 18 5.5 15.77 5.5 12.65V7.65C5.5 4.53 8.41 2 12 2C13.8 2 15.42 2.63 16.6 3.65C17.77 4.68 18.5 6.09 18.5 7.65Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Финансы<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'billingSchool' }"
                alt=""
            /></router-link>
          </li>
          <li v-if="role === 'school'" class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('teachersSchool')"
              :class="{ active: activeLink === 'teachersSchool' }"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="vuesax/twotone/teachersSchool">
                  <g
                    :class="{ active: activeLink === 'teachersSchool' }"
                    id="teachersSchool"
                  >
                    <path
                      opacity="0.4"
                      d="M18.1394 21.6198C17.2594 21.8798 16.2194 21.9998 14.9994 21.9998H8.99937C7.77937 21.9998 6.73937 21.8798 5.85938 21.6198C6.07937 19.0198 8.74937 16.9697 11.9994 16.9697C15.2494 16.9697 17.9194 19.0198 18.1394 21.6198Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22 9V15C22 18.78 20.86 20.85 18.14 21.62C17.26 21.88 16.22 22 15 22H9C7.78 22 6.74 21.88 5.86 21.62C3.14 20.85 2 18.78 2 15V9C2 4 4 2 9 2H15C20 2 22 4 22 9Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      opacity="0.4"
                      d="M15.5819 10.58C15.5819 12.56 13.9819 14.17 12.0019 14.17C10.0219 14.17 8.42188 12.56 8.42188 10.58C8.42188 8.60002 10.0219 7 12.0019 7C13.9819 7 15.5819 8.60002 15.5819 10.58Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Учительский состав<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'teachersSchool' }"
                alt=""
            /></router-link>
          </li>
          <li v-if="role != 'school'" class="sidebar__nav-item">
            <router-link
              class="sidebar__nav-link"
              to=""
              @click="toggleActive('accountSetting')"
              :class="{ active: activeLink === 'accountSetting' }"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  :class="{ active: activeLink === 'accountSetting' }"
                  id="accountSetting"
                >
                  <path
                    d="M2 9V6.5C2 4.01 4.01 2 6.5 2H9"
                    stroke="#1A1A1A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15 2H17.5C19.99 2 22 4.01 22 6.5V9"
                    stroke="#1A1A1A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M22 16V17.5C22 19.99 19.99 22 17.5 22H16"
                    stroke="#1A1A1A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 22H6.5C4.01 22 2 19.99 2 17.5V15"
                    stroke="#1A1A1A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <g opacity="0.4">
                    <path
                      d="M17 9.5V14.5C17 16.5 16 17.5 14 17.5H10C8 17.5 7 16.5 7 14.5V9.5C7 7.5 8 6.5 10 6.5H14C16 6.5 17 7.5 17 9.5Z"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19 12H5"
                      stroke="#1A1A1A"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
              </svg>
              Личные данные<img
                class="arrow-right"
                src="../../assets/image/arrow-right.svg"
                :class="{ active: activeLink === 'accountSetting' }"
                alt=""
            /></router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>


<style scoped>
.sidebar {
  padding: 43px 15px;
  background-color: #ffffff;
  width: 315px;
  position: sticky;
  top: 0;
  left: 0;
  height: 100vh;
  flex-shrink: 0;
}

.sidebar__content {
  height: 100%;
}

.sidebar__logo {
  margin: 0 15px;
  margin-bottom: 54px;
  display: inline-block;
}

.sidebar__person-img {
  border-radius: 15px;
  background: #d9d9d9;
  aspect-ratio: 75/75;
  width: 75px;
  object-fit: cover;
  object-position: center;
}

.sidebar__person-wrapp {
  display: flex;
  gap: 15px;
}

.sidebar__person {
  margin: 0 15px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.sidebar__person-regalia {
  display: flex;
  gap: 27px;
  padding: 15px 18px;
  border-radius: 10px;
  background: #f4f8fb;
  margin-bottom: 43px;
}

.sidebar__person-regalia-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  color: #1a1a1a;
  text-align: center;
  font-family: Aeroport;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.sidebar__person-regalia-text span {
  color: #80879c;
  text-align: center;
  font-family: Aeroport;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.sidebar__person-info {
  display: flex;
  flex-direction: column;
}

.sidebar__person-name {
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.sidebar__person-position {
  color: #80879c;
  font-family: Aeroport;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.sidebar__person-rating {
  color: #1a1a1a;
  text-align: center;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 6px;
}

.sidebar__nav {
  height: calc(100vh - 315px - 86px);
}

.sidebar__nav-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-shrink: 0;
  overflow-y: auto;
  border-radius: 20px;
  scroll-behavior: smooth;
}

.sidebar__nav-list {
  overflow-y: auto;
  /* Добавляем прокрутку */
  /* Прозрачный стиль для полосы и бегунка в Firefox */
  position: relative;
}

.sidebar__nav-list::-webkit-scrollbar {
  width: 3px;
  height: 70%;
  margin-top: 15%;
  margin-bottom: 15%;
}

.sidebar__nav-list::-webkit-scrollbar-track {
  background-color: transparent;
}

.sidebar__nav-list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0);
  transition: background-color 0.3s easy;
}

.sidebar__nav-list.scrolling::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}

/* Стилизация для центрального расположения */
.sidebar__nav-list {
  scrollbar-gutter: stable;
  /* Стабильный скроллбар без смещения контента */
}

.sidebar__nav-list::-webkit-scrollbar {
  height: 70%;
  /* Высота скроллбара 70% от высоты блока */
  margin-top: 15%;
  /* Центрируем скроллбар относительно высоты */
  margin-bottom: 15%;
}

.sidebar__nav-link {
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 15px;
  padding: 20px 0;
}

.sidebar__nav-link.active {
  border-radius: 15px;
  background: #1a1a1a;
  color: white;
  margin: 0;
  padding: 20px 15px;
}

g.active path {
  stroke: white;
}

.arrow-right {
  opacity: 0;
  margin-left: auto;
}

.arrow-right.active {
  opacity: 1;
}
</style>